import React from "react";
import { FormControlLabel, Switch } from "@mui/material";

const NflIncludeCflToggle = ({ includeCfl, onToggle }) => (
  <FormControlLabel
    control={
      <Switch
        checked={includeCfl}
        onChange={(e) => onToggle(e.target.checked)}
        size="small"
      />
    }
    label="Include CFL"
  />
);

export default NflIncludeCflToggle;
